var sb = require('@sb/util')

export default {
	name: 'FileAttachments',
	props: ['ev'],

	render () {
		var byType = sb.get(this.ev, 'by.type', 'agent')
		var attachments = sb.get(this.ev, 'data.message.attachments', [])
		var files = []
		sb.each(attachments, att => {
			if (!att || !att.url) return
			if (
				!sb.includes(att.mimetype, 'video') &&
				!sb.includes(att.mimetype, 'audio') &&
				!sb.includes(att.mimetype, 'image') &&
				att.type !== 'button' &&
				att.type !== 'quick_replies' &&
				att.type !== 'form' &&
				att.type !== 'form_submit'
			) {
				files.push(att)
			}
		})

		if (files.length === 0) return null

		var $files = sb.map(files, (file, index) => {
			return (
				<div key={index} class={`file-attachment file-attachment--${byType}`}>
					<a class="file-attachment--link" href={sb.replaceFileUrl(file.url)} target="_blank">
						<span class="file-attachment--download mr-2"></span>
						<span class="file-attachment--filename">{file.name}</span>
					</a>
				</div>
			)
		})

		return <div class={`message-${byType}`}>{$files}</div>
	},
}
